import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "collapse-card",
  "use": "collapse-card-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" fill-rule=\"evenodd\" stroke-linejoin=\"round\" stroke-miterlimit=\"2\" id=\"collapse-card\"><path d=\"M12,19.415L3.586,11L5,9.586L12,16.586L19,9.586L20.414,11L12,19.415Z\" fill=\"currentColor\" fill-rule=\"nonzero\" transform=\"matrix(1.30734 0 0 -1.30734 -3.688 30.957)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol